import React, {useState} from 'react';
import {Animate} from "react-simple-animate";
import {toggleFaveReadOffCanvasIsActive, toggleFaveWatchOffCanvasIsActive} from "../../../../Features/Misc/navBarSlice"
import {useDispatch} from "react-redux";
import {setActiveRead, setActiveWatch} from "../../../../Features/Misc/activeSlice";

import FaveHeart from "../../../Components/FaveHeart";
import stripHtml from "../../../Components/StripHTML";
import truncateWords from "../../../../HooksHelpers/truncateWords";

import defaultSleepImage1 from '../../../../assets/default-images/default-sleep-image-1.png';
import defaultSleepImage2 from '../../../../assets/default-images/default-sleep-image-2.png';
import defaultSleepImage3 from '../../../../assets/default-images/default-sleep-image-3.png';
import defaultSleepImage4 from '../../../../assets/default-images/default-sleep-image-4.png';
import defaultSleepImage6 from '../../../../assets/default-images/default-sleep-image-6.jpg';
import defaultSleepImage7 from '../../../../assets/default-images/default-sleep-image-7.jpg';
import defaultSleepImage8 from '../../../../assets/default-images/default-sleep-image-8.jpg';
import defaultSleepImage9 from '../../../../assets/default-images/default-sleep-image-9.jpg';
import defaultSleepImage10 from '../../../../assets/default-images/default-sleep-image-10.jpg';

function FaveReadCard(props) {

    const dispatch = useDispatch()

    const defaultImgChoice = [
        defaultSleepImage1,
        defaultSleepImage2,
        defaultSleepImage3,
        defaultSleepImage4,
        defaultSleepImage6,
        defaultSleepImage7,
        defaultSleepImage8,
        defaultSleepImage9,
        defaultSleepImage10,
    ];

    const {
        imgSrc,
        favourite,
        title,
        text,
        authorName,
        date,
        mediaType,
        mediaId
    } = props

    const randomImgNumber = Math.floor(Math.random() * 9);

    const imageUrl = imgSrc || defaultImgChoice[randomImgNumber];

    const [toggleFade, setToggleFade] = useState(false);

    const displayName = authorName ? (authorName === 'wesley@hydra' ? 'Sleep Geek' : authorName) : 'Sleep Geek';


    const mediaData = {
        mediaType,
        mediaId
    }

    const readPayload = {
        imgSrc,
        favourite,
        title,
        text,
        authorName,
        date,
        mediaType,
        mediaId
    }


    const handleCardClick = React.useCallback(() => {
        dispatch(toggleFaveReadOffCanvasIsActive());
        dispatch(setActiveRead(readPayload))
    }, [dispatch, readPayload]);


    return (
        <>
            <Animate
                play={toggleFade}
                start={{ opacity: 1, paddingRight: "12px", paddingBottom: "12px" }}
                end={{ opacity: 0, paddingRight: "12px", paddingBottom: "12px"}}
                duration={0.1}
            >


                <div onClick={handleCardClick} className={`bg-pink-dashboard rounded-lg w-12/12 sm:w-full p-4 sm:gap-8 gap-4 flex flex-col sm:flex-row sm:h-64 xl:h-76 cursor-pointer hover:opacity-60 transition-opacity duration-300`}>

                    <div onClick={() => { dispatch(toggleFaveReadOffCanvasIsActive()); dispatch(setActiveRead(readPayload))} }  className="readFeaturedCard-imageContainer h-32 sm:h-full w-full flex flex-row gap-6 justify-between lg:w-1/2">
                        <div className="readFeaturedCard-image w-11/12 sm:w-full h-full object-fill  rounded-lg  bg-cover no-repeat bg-center " style={{backgroundImage: `url(${imageUrl}` }}></div>
                        <div className="sm:hidden block readFeaturedCard-favourite mr-0 ml-auto">
                            <FaveHeart type={"Read"} mediaId={mediaId} mediaType={mediaType} fadeFunction={() => setToggleFade(!toggleFade)}/>
                        </div>
                    </div>

                    <div className="readFeaturedCard-details lg:w-1/2 flex flex-col justify-between ">
                        <div className="hidden sm:block readFeaturedCard-favourite mr-0 ml-auto">
                            <FaveHeart type={"Read"} mediaId={mediaId} mediaType={mediaType} fadeFunction={() => setToggleFade(!toggleFade)}/>
                        </div>

                        <div className="faveReadFeaturedCard_details flex gap-2  pb-2  flex-col sm:gap-4  sm:pb-4 ">
                            <div   onClick={() => { dispatch(toggleFaveReadOffCanvasIsActive()); dispatch(setActiveRead(readPayload))} } className="faveReadFeaturedCard_details-title text-lg cursor-pointer">{stripHtml(truncateWords(title, 7))}...</div>
                            <div className="faveReadFeaturedCard_details-text text-xs sm:text-sm">{stripHtml(text.length > 120 ? text.slice(0, 120) + "..." : text)}</div>
                            <div className="faveReadFeaturedCard_details-author flex flex-row items-center mb-0 mt-auto">
                                <div className="faveReadFeaturedCard_details-author-avatar w-8 h-8 rounded-full bg-gold-accent mr-2" />
                                <div  className="faveReadFeaturedCard_details-author-name font-semibold text-white text-xs">{displayName}</div>
                            </div>
                        </div>
                    </div>

                </div>
            </Animate>

        </>
    );
}

export default FaveReadCard;
